module.exports = __webpack_public_path__ + "img/orchid-2.c529718b.jpeg";